<template>
  <v-container fluid class="page">
    <div class="page-hero">
      <div>
        <h2 class="d-flex align-center">Auditoria <HelpHint text="Bitácora de acciones sensibles del sistema para trazabilidad y cumplimiento." /></h2>
        <p>Registro de eventos y actividad.</p>
      </div>
    </div>
    <v-card outlined class="page-card">
      <p class="placeholder">Modulo en preparacion.</p>
    </v-card>
  </v-container>
</template>

<script>
import HelpHint from "@/components/HelpHint.vue";

export default {
  name: "SecurityAudit",
  components: { HelpHint },
};
</script>

<style scoped>
.page {
  padding: 0;
}

.page-hero {
  background: var(--bg-card);
  border-radius: 16px;
  padding: 24px 28px;
  margin-bottom: 20px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-subtle);
}

.page-hero h2 {
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.02em;
}

.page-hero p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.5;
}

.page-card {
  background: var(--bg-card);
  border-radius: 16px;
  padding: 20px 24px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-subtle);
}

.placeholder {
  margin: 0;
  color: var(--text-secondary);
}
</style>
